import { useMutation } from '@apollo/client';
import { IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonChip, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonPage, IonTitle, IonToolbar, useIonViewWillEnter } from '@ionic/react';
import BTCPAY from 'assets/icons/btcpay.svg';
import Galoy from 'assets/icons/galoy.png';
import IBEX from 'assets/icons/IBEX_Logo_04.png';
import OpenNode from 'assets/icons/opennode.svg';
import { AuthContext } from 'contexts/AuthContext';
import { UPDATE_DEFAULT_PROVIDER } from 'graphql/mutations';
import useMerchantProfile from 'hooks/useMerchantProfile';
import { add, chevronBackOutline } from 'ionicons/icons';
import { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router';

const LSPList = () => {
  const { authState } = useContext(AuthContext);
  const history = useHistory();
  const { data, loading, refetch } = useMerchantProfile(authState.user.uid, true);
  const [defaultProvider, setDefaultProvider] = useState(null);

  const [updateProvider] = useMutation(UPDATE_DEFAULT_PROVIDER)

  useIonViewWillEnter(() => {
    refetch();
  })

  useEffect(() => {
    if (!defaultProvider && data?.merchants[0]?.provider_keys?.length > 0 && data?.merchants[0]?.provider_keys?.filter(x => x.default === true).length > 0) {
      setDefaultProvider(data?.merchants[0]?.provider_keys?.filter(x => x.default === true)[0].id);
    } else if (!defaultProvider && data?.merchants[0]) {
      setDefaultProvider('opennode')
    }
  }, [data])

  const setDefault = async (id) => {
    if (defaultProvider !== id) {
      setDefaultProvider(id);
      if (data?.merchants[0]?.provider_keys?.filter(x => x.default === true).length > 0) {
        const defaultMerchant = data?.merchants[0]?.provider_keys?.filter(x => x.default === true)[0];
        const payload = {
          variables: {
            id: defaultMerchant.id,
            default: false
          }
        }
        await updateProvider(payload);
      }
      const payload = {
        variables: {
          id: id,
          default: true
        }
      }
      await updateProvider(payload);
    }
  }

  const setOpenNodeDefault = async () => {
    if (defaultProvider !== 'opennode') {
      setDefaultProvider('opennode');
      data?.merchants[0]?.provider_keys?.map(async (provider) => {
        const payload = {
          variables: {
            id: provider.id,
            default: false
          }
        }
        await updateProvider(payload);
      })
    }
  }

  return (
    <IonPage className={'ln-service-provider-root'}>
      <IonHeader className={'ion-no-border'}>
        <IonToolbar className={'background-color'}>
          <IonButtons slot="start">
            <IonButton
              fill="clear"
              onClick={() => history.goBack()}><IonIcon icon={chevronBackOutline} /></IonButton>
          </IonButtons>
          <IonTitle>Lightning Service Providers</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={() => history.push('/account/lsp/select')}>
              <IonIcon icon={add} /> Add
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonList lines="none">
          {!loading && data?.merchants?.length === 0 ? (
            <IonItem
              lines="none"
              color="danger"
              className={"alert-banner"}
              routerLink={"/account/business"}
            >
              <IonLabel>Continue account setup to enable LSPs</IonLabel>
            </IonItem>
          ) : !loading && data?.merchants?.length > 0 && (
            <>
              {data?.merchants[0]?.id && !data?.merchants[0]?.opennode_account_id && !data?.merchants[0]?.opennode_key_public && !data?.merchants[0]?.provider_key && data?.merchants[0]?.provider_keys?.length === 0 &&
                <IonButton onClick={() => history.push('/account/lsp/select')} expand="block" style={{ margin: 16 }}>Add Provider</IonButton>
              }
              {data?.merchants[0]?.provider_keys?.length > 0 && data?.merchants[0]?.provider_keys?.map((provider, i) => {
                return <div key={provider.provider_name + i}>
                  {provider.provider_name === "ibex" &&
                    <IonCard
                      onClick={() => setDefault(provider.id)}
                      className={'ln-service-card ibex'}>
                      <IonCardHeader>
                        <IonToolbar className={"transparent"}>
                          <div slot="start" className={"logo-container ibex"}><img src={IBEX} alt="IBEX" /></div>
                          <IonChip slot="end">{defaultProvider === provider.id ? 'default' : 'set default'}</IonChip>
                        </IonToolbar>
                      </IonCardHeader>
                      <IonCardContent>
                        <h1>We make Bitcoin easy.</h1>
                      </IonCardContent>
                    </IonCard>
                  }
                  {provider.provider_name === "btcpay" &&
                    <IonCard
                      className={'ln-service-card'}
                      onClick={() => setDefault(provider.id)}>
                      <IonCardHeader>
                        <IonToolbar className={"transparent"}>
                          <div slot="start" className={"logo-container opennode"}><img src={BTCPAY} alt="btcpay" style={{ height: '40px', width: 'auto', marginLeft: '-10px' }} /></div>
                          <IonChip slot="end">{defaultProvider === provider.id ? 'default' : 'set default'}</IonChip>
                        </IonToolbar>
                      </IonCardHeader>
                      <IonCardContent>
                        <h1>Self-Hosted Bitcoin Payment Gateway.</h1>
                      </IonCardContent>
                    </IonCard>}
                </div>
              })}
              {data?.merchants[0]?.opennode_account_id ?
                <IonCard
                  disabled
                  onClick={() => setOpenNodeDefault()}
                  className={'ln-service-card'}>
                  <IonCardHeader>
                    <IonToolbar className={"transparent"}>
                      <div slot="start" className={"logo-container opennode"}><img src={OpenNode} alt="opennode" /></div>
                      <IonChip slot="end">{defaultProvider !== 'opennode' ? 'set default' : 'default'}</IonChip>
                    </IonToolbar>
                  </IonCardHeader>
                  <IonCardContent>
                    <h1>Bitcoin Payments at the Speed of Now.</h1>
                  </IonCardContent>
                </IonCard> :
                data?.merchants[0]?.opennode_key_public &&
                <IonCard
                  className={'ln-service-card'}>
                  <IonCardHeader>
                    <IonToolbar className={"transparent"}>
                      <div slot="start" className={"logo-container opennode"}><img src={OpenNode} alt="opennode" /></div>
                      <IonChip slot="end">{defaultProvider !== 'opennode' ? 'set default' : 'default'}</IonChip>
                    </IonToolbar>
                  </IonCardHeader>
                  <IonCardContent>
                    <h1>Bitcoin Payments at the Speed of Now.</h1>
                  </IonCardContent>
                </IonCard>}
              {data?.merchants[0]?.provider_key &&
                <IonCard
                  className={'ln-service-card'}>
                  <IonCardHeader>
                    <IonToolbar className={"transparent"}>
                      <div slot="start" className={"logo-container opennode"}><img src={Galoy} alt="galoy" /></div>
                      <IonChip slot="end">El Salvador</IonChip>
                    </IonToolbar>
                  </IonCardHeader>
                  <IonCardContent>
                    <h1>Bitcoin Beach Wallet</h1>
                  </IonCardContent>
                </IonCard>
              }
            </>
          )}

        </IonList>
      </IonContent>
    </IonPage >
  )
}

export default LSPList
